import { useState, useEffect } from 'react';

const getLocation = () => {
  if (typeof window === 'undefined') {
    return { pathname: '', search: '', hash: '' };
  }
  return {
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
  };
};

/**
 * Hook que retorna um objeto location (pathname, search, hash) compatível
 * com o formato do @reach/router, para uso em ambiente Gatsby sem depender do @reach/router.
 * Atualiza quando o usuário navega (ex.: botão voltar/avançar).
 */
function useLocation() {
  const [location, setLocation] = useState(getLocation);

  useEffect(() => {
    const handlePopState = () => setLocation(getLocation());
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return location;
}

export default useLocation;
